import { render, staticRenderFns } from "./DocumentImageViewer.vue?vue&type=template&id=4bca7240&"
import script from "./DocumentImageViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentImageViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports